import { apiClientPublic } from "services/api-client"

export const sendVerifyCode = async (email, companyId) => {
  return await apiClientPublic.post(`user/auth/send-verify-code`, {
    email,
    companyId
  })
}

export const userAuth = async (email, code, companyKey) => {
  return await apiClientPublic.post(`user/auth`, {
    code,
    email,
    companyKey
  })
}